import {useState} from 'react';

interface IUseBatchEditFields {
    addedFields: string[],
    addField: (_key: string) => void,
    removeField: (_key: string) => void,
}

const useBatchEditFields = (onRemove?: (_key: string) => void): IUseBatchEditFields => {
    const [addedFields, setAddedFields] = useState<string[]>([]);

    const addField = (key: string) => {
        setAddedFields(prev => (prev.includes(key) ? prev : [...prev, key]));
    };

    const removeField = (key: string) => {
        setAddedFields(prev => prev.filter(fieldKey => fieldKey !== key));
        onRemove?.(key);
    };

    return {addedFields, addField, removeField};
};

export default useBatchEditFields;
